import { createEventDefinition } from 'ts-bus';

const EVENT_PROFILE_UPDATED = 'EVENT_PROFILE_UPDATED';

export const profileUpdated = createEventDefinition<{
  userName: string;
  userEmail: string | null;
  userRole: string;
  userPictureUrl: string | undefined;
}>()(EVENT_PROFILE_UPDATED);
